import React from 'react';
import './App.css';
import Routes from 'routes';
import useStore, { history } from 'store';
import 'react-datepicker/dist/react-datepicker.css';

const App: React.FC = () => {
  const { isReady } = useStore();

  if (!isReady) {
    return <p>We're getting things ready...</p>;
  }

  return <Routes history={history} />;
};

export default App;